<template>
  <div style="padding:14px 10px">
    <div class="cur_route">{{$route.name}}</div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home/index' }">Dashboard</el-breadcrumb-item>
      <el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="conts fcl">
      <div class="frw fac">
        <div class="nav_item frw fac " :class="{nav_item_s:i==nav_index}" v-for="(item,i) in navs" :key="i"
          @click="navChange(i)">{{item}}
        </div>
      </div>
      <div class="div_cont box-sizing">
        <transaction v-if="nav_index==0" />
        <transactionBackups v-if="nav_index==1" />
      </div>
    </div>

  </div>
</template>
<script>
  import transaction from './transaction.vue'
  import transactionBackups from './transaction_backups.vue'
  export default {
    components: {
      transaction,
      transactionBackups,
    },
    data() {
      return {
        navs: ['Transaction Lists', 'Transaction Backups'],
        nav_index: 0
      }
    },
    methods: {
      navChange(i) {
        this.nav_index = i
      }
    }
  }

</script>
<style scoped>
  .conts {
    margin-top: 20px;
  }

  .nav_item {
    height: 50px;
    padding: 0 22px;
    background: rgba(0, 184, 194, .05);
    border-radius: 16px 16px 0 0;
    color: rgba(11, 50, 117, .7);
    font-size: 14px;
    margin-right: 1px;
    border: 1px solid #fff;
    cursor: pointer;
  }

  .nav_item_s {
    color: #00b8c2;
    background: #fff;
    box-shadow: 5px 0 10px rgba(3, 97, 240, .12);
  }

</style>



// WEBPACK FOOTER //
// src/views/transaction/transfers.vue